<template>
  <div class="profil-container">
    <need-review
      :title="'Need Review'"
      :modalClose="closeReviewHead"
      :submit="needReviewHead"
      v-if="is_catatan_head_open"
    />
    <need-review
      :title="'Need Review SIPM'"
      :modalClose="close"
      :submit="needReviewHSE"
      v-if="is_catatan_open"
    />
    <block-label :label="'HASIL PENILAIAN SEMENTARA'" />
    <form-result-kplh
      :tables="tableInput.inputForm1"
      :listInput="[
        {
          type: 'text',
          name: 'Kritis',
          // t_bobot: tableResiko.kritis,
          t_bobot: bobot_kritis,
          t_nilai: total_kritis,
          p_nilai: `${countValue().toFixed(2)} %`,
          p_lulus: `75 %`,
          note:
            countValue() >= 75
              ? 'LULUS PRAQUALIFIKASI'
              : 'TIDAK LULUS PRAQUALIFIKASI',
        },
        {
          type: 'text',
          name: 'Tinggi',
          // t_bobot: tableResiko.tinggi,
          t_bobot: bobot_tinggi,
          t_nilai: total_tinggi,
          p_nilai: `${countValue().toFixed(2)} %`,
          p_lulus: `75 %`,
          note:
            countValue() >= 75
              ? 'LULUS PRAQUALIFIKASI'
              : 'TIDAK LULUS PRAQUALIFIKASI',
        },
        {
          type: 'text',
          name: 'Sedang',
          // t_bobot: tableResiko.sedang,
          t_bobot: bobot_sedang,
          t_nilai: total_sedang,
          p_nilai: `${countValue().toFixed(2)} %`,
          p_lulus: `75 %`,
          note:
            countValue() >= 75
              ? 'LULUS PRAQUALIFIKASI'
              : 'TIDAK LULUS PRAQUALIFIKASI',
          options: [0, 1, 2, 3],
        },
        {
          type: 'text',
          name: 'Rendah',
          // t_bobot: tableResiko.rendah,
          t_bobot: bobot_rendah,
          t_nilai: total_rendah,
          p_nilai: `${countValue().toFixed(2)} %`,
          p_lulus: `75 %`,
          note:
            countValue() >= 75
              ? 'LULUS PRAQUALIFIKASI'
              : 'TIDAK LULUS PRAQUALIFIKASI',
        },
      ]"
      :modelName="'addedIUJP'"
      :isRequired="false"
      :mutationName="'kplhStore/SET_KPLH_FORM'"
      :storeName="'kplhStore'"
      :modalName="'modal_add_iujp'"
      :disabled="is_hse_validation || is_preview"
    />

    <block-label :label="'HASIL PENILAIAN FINAL'" />
    <form-result-kplh
      :tables="tableInput.inputForm2"
      :listInput="[
        {
          type: 'form',
          t_resiko: $tingkatResikoValue(),
          t_bobot: total_bobot,
          p_nilai: `${countValue().toFixed(2)} %`,
          notes_options: notes_options,
          head_hse_options: head_hse_options,
          ktt_options: ktt_options,
        },
      ]"
      :modelName="'addedIUJP'"
      :isRequired="false"
      :mutationName="'kplhStore/SET_KPLH_FORM'"
      :storeName="'kplhStore'"
      :modalName="'modal_add_iujp'"
      :disabled="is_hse_validation || is_preview"
    />

    <div class="vendor-form-wrapper">
      <input-text-area
        :label="'Catatan'"
        :modelName="'catatan'"
        :isRequired="false"
        :mutationName="'kplhStore/SET_KPLH_FORM'"
        :storeName="'kplhStore'"
        :disabled="is_hse_validation || is_preview"
      />
    </div>

    <div class="profil-btn-wrapper">
      <div @click="open()" class="btn-landing" v-if="buttonDisabled('hse')">
        Need Review SIPM
      </div>
      <div
        @click="submitNilai()"
        class="btn-landing"
        v-if="buttonDisabled('hse')"
      >
        Submit Nilai
      </div>

      <div
        @click="approveHead()"
        class="btn-landing"
        v-if="buttonDisabled('head')"
      >
        Approve
      </div>
      <div
        @click="openReviewHead()"
        class="btn-landing"
        v-if="buttonDisabled('head')"
      >
        Need Review
      </div>

      <div @click="goBack()" class="btn-landing">Kembali</div>
    </div>
  </div>
</template>
<script>
import BlockLabel from '../../components/forms/label/blockLabel.vue'
import FormResultKplh from '../../components/forms/form-result-kplh.vue'
import InputFormPenilaianKplh from '../../components/forms/input-form-penilaian-kplh.vue'
import InputTextArea from '../../components/forms/input-text-area.vue'

import axios from 'axios'
import { api_lp, api } from '../../services/config'
export default {
  components: {
    BlockLabel,
    FormResultKplh,
    InputFormPenilaianKplh,
    InputTextArea,
    NeedReview: () => import('@/components/customModal/need-review.vue'),
  },
  data() {
    return {
      selesai: 0,
      done: 1,
      is_catatan_open: false,
      // tableResiko: {
      //   kritis: bobot_kritis,
      //   tinggi: bobot_tinggi,
      //   sedang: bobot_sedang,
      //   rendah: bobot_rendah,
      // },
      notes_options: [
        {
          id: null,
          name: 'Pilih Keterangan',
        },
        {
          id: 'TIDAK LULUS PRAQUALIFIKASI',
          name: 'TIDAK LULUS PRAQUALIFIKASI',
        },
        {
          id: 'LULUS PRAQUALIFIKASI',
          name: 'LULUS PRAQUALIFIKASI',
        },
        {
          id: 'LULUS DENGAN CATATAN',
          name: 'LULUS DENGAN CATATAN',
        },
      ],
      tableInput: {
        inputForm1: [
          {
            name: 'Tingkat Resiko',
            obj_name: 'tingkat_resiko',
            css: 'column15 mr10 col-nohover',
            input: false,
            type: 'name',
          },
          {
            name: 'Total Bobot',
            obj_name: 't_bobot',
            css: 'column15 mr10',
            input: false,
            type: 't_bobot',
          },
          {
            name: 'Total Nilai',
            obj_name: 't_nilai',
            css: 'column10 mr10',
            input: false,
            type: 't_nilai',
          },
          {
            name: 'Presentasi Nilai',
            obj_name: 'presentasi_nilai',
            css: 'column15',
            input: false,
            type: 'p_nilai',
          },
          {
            name: 'Presentasi Kelulusan',
            obj_name: 'presentasi_kelulusan',
            css: 'column20',
            input: false,
            type: 'p_lulus',
          },
          {
            name: 'Keterangan',
            obj_name: 'keterangan',
            css: 'column25',
            input: false,
            type: 'note',
          },
        ],
        inputForm2: [
          {
            name: 'Tingkat Resiko Bidang Usaha',
            obj_name: 'jenis',
            css: 'column20 mr10 col-nohover',
            input: false,
            type: 't_resiko',
          },
          {
            name: 'Tingkat Bobot',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 't_bobot',
          },
          {
            name: 'Presentasi Nilai',
            obj_name: 'jenis',
            css: 'column15 mr10',
            input: false,
            type: 'p_nilai',
          },
          {
            name: 'Keterangan',
            obj_name: 'bobot',
            css: 'column20',
            input: true,
            type: 'select',
            optionModel: 'final_result_notes',
            optionList: 'notes_options',
          },
          {
            name: 'TTD Level Head HSE',
            obj_name: 'value',
            css: 'column25 col-nohover',
            input: true,
            type: 'select',
            optionModel: 'tdd_head_hse',
            optionList: 'head_hse_options',
          },
          {
            name: 'TTD Level KTT',
            obj_name: 'note',
            css: 'column15 col-nohover',
            input: true,
            type: 'select',
            optionModel: 'tdd_ktt',
            optionList: 'ktt_options',
          },
        ],
      },
      listInput: {
        // inputForm1: [
        //   {
        //     type: 'text',
        //     name: 'Kritis',
        //     t_bobot: '185',
        //     t_nilai: this.total_kritis,
        //     p_nilai: `0 %`,
        //     p_lulus: `75 %`,
        //     note: 'TIDAK LULUS PRAQUALIFIKASI',
        //     options: [0, 1, 2, 3],
        //     optionStore: 'penilaian_grup1_11',
        //     inputStore: 'note_grup1_11',
        //   },
        //   {
        //     type: 'text',
        //     name: 'Tinggi',
        //     t_bobot: '185',
        //     t_nilai: '0',
        //     p_nilai: `0 %`,
        //     p_lulus: `75 %`,
        //     note: 'TIDAK LULUS PRAQUALIFIKASI',
        //     options: [0, 1, 2, 3],
        //     optionStore: 'penilaian_grup1_11',
        //     inputStore: 'note_grup1_11',
        //   },
        //   {
        //     type: 'text',
        //     name: 'Sedang',
        //     t_bobot: '185',
        //     t_nilai: '0',
        //     p_nilai: `0 %`,
        //     p_lulus: `75 %`,
        //     note: 'TIDAK LULUS PRAQUALIFIKASI',
        //     options: [0, 1, 2, 3],
        //     optionStore: 'penilaian_grup1_11',
        //     inputStore: 'note_grup1_11',
        //   },
        //   {
        //     type: 'text',
        //     name: 'Rendah',
        //     t_bobot: '185',
        //     t_nilai: '0',
        //     p_nilai: `0 %`,
        //     p_lulus: `75 %`,
        //     note: 'TIDAK LULUS PRAQUALIFIKASI',
        //     options: [0, 1, 2, 3],
        //     optionStore: 'penilaian_grup1_11',
        //     inputStore: 'note_grup1_11',
        //   },
        // ],
        inputForm2: [
          {
            type: 'form',
            t_resiko: 'Tinggi',
            t_resiko: 'Rendah',
            t_bobot: '122',
            p_nilai: `0 %`,
            notes_options: ['LULUS DENGAN CATATAN', '-', '-'],
            head_hse_options: ['LEVEL HSE OPTION', '-', '-'],
            ktt_options: ['LEVEL KTT OPTION', '-', '-'],
          },
        ],
      },
      hseOptions: [],
    }
  },
  async created() {
    this.getHseUser()
    console.log('Head HSE', this.is_head_approved)
    console.log(
      'total sedang',
      this.total_sedang,
      typeof this.total_sedang,
      typeof this.total_rendah
    )
  },
  computed: {
    total_bobot() {
      const tingkatResiko = this.$tingkatResikoValue().toLowerCase()

      if (tingkatResiko === 'kritis') return this.bobot_kritis
      if (tingkatResiko === 'tinggi') return this.bobot_tinggi
      if (tingkatResiko === 'sedang') return this.bobot_sedang
      if (tingkatResiko === 'rendah') return this.bobot_rendah
    },
    bobot_kritis() {
      return this.$store.state.kplhStore.bobot_kritis
    },
    bobot_tinggi() {
      return this.$store.state.kplhStore.bobot_tinggi
    },
    bobot_sedang() {
      return this.$store.state.kplhStore.bobot_sedang
    },
    bobot_rendah() {
      return this.$store.state.kplhStore.bobot_rendah
    },
    total_kritis() {
      return this.$store.state.kplhStore.total_kritis
    },
    total_tinggi() {
      return this.$store.state.kplhStore.total_tinggi
    },
    total_sedang() {
      return this.$store.state.kplhStore.total_sedang
    },
    total_rendah() {
      return this.$store.state.kplhStore.total_rendah
    },
    tingkat_resiko() {
      return this.$store.state.kplhStore.tingkat_resiko
    },
    ktt_options() {
      return this.$store.state.kplhStore.ktt_options
    },
    head_hse_options() {
      return this.$store.state.kplhStore.head_hse_options
    },
    is_hse_validation() {
      return this.$store.state.kplhStore.is_hse_validation
    },
    is_preview() {
      return this.$store.state.kplhStore.is_preview
    },
    is_head_approved() {
      return this.$store.state.kplhStore.is_head_approved
    },
    is_catatan_head_open() {
      return this.$store.state.kplhStore.is_catatan_head_open
    },
  },
  methods: {
    buttonDisabled(value) {
      let isHeadPage = false
      if (this.$route.path.indexOf('kplh-head-validation') != -1) {
        isHeadPage = true
      }

      if (isHeadPage) {
        switch (value) {
          case 'head':
            return true
            break
          case 'hse':
            return this.$store.state.kplhStore.is_hse_validation
            break

          default:
            break
        }
      } else {
        switch (value) {
          case 'head':
            return false
            break
          case 'hse':
            return !this.$store.state.kplhStore.is_hse_validation
            break

          default:
            break
        }
      }
    },
    goBack() {
      this.$store.commit('kplhStore/SET_ACTIVE_PAGE', { name: 'grupjm' })
    },
    countValue() {
      const tingkatResiko = this.$tingkatResikoValue().toLowerCase()

      let total_risiko_value = 0
      if (tingkatResiko == 'kritis') total_risiko_value = this.total_kritis
      if (tingkatResiko == 'tinggi') total_risiko_value = this.total_tinggi
      if (tingkatResiko == 'sedang') total_risiko_value = this.total_sedang
      if (tingkatResiko == 'rendah') total_risiko_value = this.total_rendah

      console.log(
        'count value:'
        // (Number(total_risiko_value) / Number(this.tableResiko[tingkatResiko])) * 100
        // (Number(total_risiko_value) / this.bobot_kritis) * 100
        // (Number(total_risiko_value) / this.bobot_tinggi) * 100
        // (Number(total_risiko_value) / this.bobot_sedang) * 100
        // (Number(total_risiko_value) / this.bobot_rendah) * 100
      )

      // (Number(total_risiko_value) / this.bobot_kritis) * 100
      if (tingkatResiko == 'kritis')
        return Number((Number(total_risiko_value) / this.bobot_kritis) * 100)
      if (tingkatResiko == 'tinggi')
        return Number((Number(total_risiko_value) / this.bobot_tinggi) * 100)
      if (tingkatResiko == 'sedang')
        return Number((Number(total_risiko_value) / this.bobot_sedang) * 100)
      if (tingkatResiko == 'rendah')
        return Number((Number(total_risiko_value) / this.bobot_rendah) * 100)
      return Number(
        (Number(total_risiko_value) / Number(this.tableResiko[tingkatResiko])) *
          100
      )
    },
    checkForm() {
      const tingkatResiko = this.$tingkatResikoValue().toLowerCase()
      const {
        tdd_head_hse,
        final_result_notes,
        value_a_1,
        value_a_2,
        value_b_1,
        value_b_2,
        value_b_3,
        value_b_4,
        value_c_1,
        value_c_2,
        value_d_1,
        value_d_2,
        value_e_1,
        value_e_2,
        value_e_3,
        value_f_1,
        value_f_2,
        value_f_3,
        value_f_4,
        value_g_1,
        value_g_2,
        value_g_3,
        value_h_1,
        value_i1_1,
        value_i1_2,
        value_i2_1,
        value_i2_2,
        value_i2_3,
        value_i2_4,
        value_i31_1,
        value_i31_2,
        value_i31_3,
        value_i31_4,
        value_i32_1,
        value_i33_1,
        value_i33_2,
        value_i34_1,
        value_i34_2,
        value_i34_3,
        value_i4_1,
        value_i4_2,
        value_i4_3,
        value_i51_1,
        value_i51_2,
        value_i52_1,
        value_i52_2,
        value_i52_3,
        value_i53_1,
        value_i53_2,
        value_i54_1,
        value_i54_2,
        value_i54_3,
        value_i6_1,
        value_i6_2,
        value_i7_1,
        value_i7_2,
        value_i8_1,
        value_i8_2,
        value_i8_3,
        value_i9_1,
        value_i9_2,
        value_j_1,
        value_j_2,
        value_j_3,
        value_j_4,
        value_k_1,
        value_k_2,
        value_l_1,
        value_l_2,
        value_l_3,
        value_m_1,
        value_m_2,
        value_m_3,
      } = this.$store.state.kplhStore

      let arr = [
        [final_result_notes, 'Keterangan'],
        [tdd_head_hse, `TDD Level Head HSE`],
      ]

      if (tingkatResiko == 'kritis') {
        arr = [
          ...arr,
          [value_a_1, 'Form Penilaian A 1'],
          [value_a_2, 'Form Penilaian A 2'],
          [value_b_1, 'Form Penilaian B 1'],
          [value_b_2, 'Form Penilaian B 2'],
          [value_b_3, 'Form Penilaian B 3'],
          [value_b_4, 'Form Penilaian B 4'],
          [value_c_1, 'Form Penilaian C 1'],
          [value_c_2, 'Form Penilaian C 2'],
          [value_d_1, 'Form Penilaian D 1'],
          [value_d_2, 'Form Penilaian D 2'],
          [value_e_1, 'Form Penilaian E 1'],
          [value_e_2, 'Form Penilaian E 2'],
          [value_e_3, 'Form Penilaian E 3'],
          [value_f_1, 'Form Penilaian F 1'],
          [value_f_2, 'Form Penilaian F 2'],
          [value_f_3, 'Form Penilaian F 3'],
          [value_f_4, 'Form Penilaian F 4'],
          [value_g_1, 'Form Penilaian G 1'],
          [value_g_2, 'Form Penilaian G 2'],
          [value_g_3, 'Form Penilaian G 3'],
          [value_h_1, 'Form Penilaian H 1'],
          [value_i1_1, 'Form Penilaian I 1-1'],
          [value_i1_2, 'Form Penilaian I 1-2'],
          [value_i2_1, 'Form Penilaian I 2-1'],
          [value_i2_2, 'Form Penilaian I 2-2'],
          [value_i2_3, 'Form Penilaian I 2-3'],
          [value_i2_4, 'Form Penilaian I 2-4'],
          [value_i31_1, 'Form Penilaian I 3-1-1'],
          [value_i31_2, 'Form Penilaian I 3-1-2'],
          [value_i31_3, 'Form Penilaian I 3-1-3'],
          [value_i31_4, 'Form Penilaian I 3-1-4'],
          [value_i32_1, 'Form Penilaian I 3-2-1'],
          [value_i33_1, 'Form Penilaian I 3-3-1'],
          [value_i33_2, 'Form Penilaian I 3-3-2'],
          [value_i34_1, 'Form Penilaian I 3-4-1'],
          [value_i34_2, 'Form Penilaian I 3-4-2'],
          [value_i34_3, 'Form Penilaian I 3-4-3'],
          [value_i4_1, 'Form Penilaian I 4-1'],
          [value_i4_2, 'Form Penilaian I 4-2'],
          [value_i4_3, 'Form Penilaian I 4-3'],
          [value_i51_1, 'Form Penilaian I 5-1-1'],
          [value_i51_2, 'Form Penilaian I 5-1-2'],
          [value_i52_1, 'Form Penilaian I 5-2-1'],
          [value_i52_2, 'Form Penilaian I 5-2-2'],
          [value_i52_3, 'Form Penilaian I 5-2-3'],
          [value_i53_1, 'Form Penilaian I 5-3-1'],
          [value_i53_2, 'Form Penilaian I 5-3-2'],
          [value_i54_1, 'Form Penilaian I 5-4-1'],
          [value_i54_2, 'Form Penilaian I 5-4-2'],
          [value_i54_3, 'Form Penilaian I 5-4-3'],
          [value_i6_1, 'Form Penilaian I 6-1'],
          [value_i6_2, 'Form Penilaian I 6-2'],
          [value_i7_1, 'Form Penilaian I 7-1'],
          [value_i7_2, 'Form Penilaian I 7-2'],
          [value_i8_1, 'Form Penilaian I 8-1'],
          [value_i8_2, 'Form Penilaian I 8-2'],
          [value_i8_3, 'Form Penilaian I 8-3'],
          [value_i9_1, 'Form Penilaian I 9-1'],
          [value_i9_2, 'Form Penilaian I 9-2'],
          [value_j_1, 'Form Penilaian J 1'],
          [value_j_2, 'Form Penilaian J 2'],
          [value_j_3, 'Form Penilaian J 3'],
          [value_j_4, 'Form Penilaian J 4'],
          [value_k_1, 'Form Penilaian K 1'],
          [value_k_2, 'Form Penilaian K 2'],
          [value_l_1, 'Form Penilaian L 1'],
          [value_l_2, 'Form Penilaian L 2'],
          [value_l_3, 'Form Penilaian L 3'],
          [value_m_1, 'Form Penilaian M 1'],
          [value_m_2, 'Form Penilaian M 2'],
          [value_m_3, 'Form Penilaian M 3'],
        ]
      }
      if (tingkatResiko == 'tinggi') {
        arr = [
          ...arr,
          [value_a_2, 'Form Penilaian A 2'],
          [value_c_1, 'Form Penilaian C 1'],
          [value_d_1, 'Form Penilaian D 1'],
          [value_d_2, 'Form Penilaian D 2'],
          [value_e_2, 'Form Penilaian E 2'],
          [value_e_3, 'Form Penilaian E 3'],
          [value_f_1, 'Form Penilaian F 1'],
          [value_f_2, 'Form Penilaian F 2'],
          [value_f_3, 'Form Penilaian F 3'],
          [value_g_1, 'Form Penilaian G 1'],
          [value_i2_1, 'Form Penilaian I 2-1'],
          [value_i31_1, 'Form Penilaian I 3-1-1'],
          [value_i31_2, 'Form Penilaian I 3-1-2'],
          [value_i32_1, 'Form Penilaian I 3-2-1'],
          [value_i34_1, 'Form Penilaian I 3-4-1'],
          [value_i34_3, 'Form Penilaian I 3-4-3'],
          [value_i4_1, 'Form Penilaian I 4-1'],
          [value_i4_2, 'Form Penilaian I 4-2'],
          [value_i4_3, 'Form Penilaian I 4-3'],
          [value_i51_1, 'Form Penilaian I 5-1-1'],
          [value_i51_2, 'Form Penilaian I 5-1-2'],
          [value_i52_2, 'Form Penilaian I 5-2-2'],
          [value_i52_3, 'Form Penilaian I 5-2-3'],
          [value_i54_1, 'Form Penilaian I 5-4-1'],
          [value_i54_3, 'Form Penilaian I 5-4-3'],
          [value_i6_1, 'Form Penilaian I 6-1'],
          [value_i6_2, 'Form Penilaian I 6-2'],
          [value_i7_1, 'Form Penilaian I 7-1'],
          [value_i8_2, 'Form Penilaian I 8-2'],
          [value_i9_1, 'Form Penilaian I 9-1'],
          [value_j_1, 'Form Penilaian J 1'],
          [value_j_2, 'Form Penilaian J 2'],
          [value_j_3, 'Form Penilaian J 3'],
          [value_j_4, 'Form Penilaian J 4'],
          [value_k_1, 'Form Penilaian K 1'],
          [value_k_2, 'Form Penilaian K 2'],
        ]
      }
      if (tingkatResiko == 'sedang') {
        arr = [
          ...arr,
          [value_a_1, 'Form Penilaian A 1'],
          [value_b_1, 'Form Penilaian B 1'],
          [value_b_2, 'Form Penilaian B 2'],
          [value_b_3, 'Form Penilaian B 3'],
          [value_b_4, 'Form Penilaian B 4'],
          [value_g_2, 'Form Penilaian G 2'],
          [value_g_3, 'Form Penilaian G 3'],
          [value_h_1, 'Form Penilaian H 1'],
          [value_i2_2, 'Form Penilaian I 2-2'],
          [value_i2_3, 'Form Penilaian I 2-3'],
          [value_i7_2, 'Form Penilaian I 7-2'],
          [value_i8_3, 'Form Penilaian I 8-3'],
        ]
      }
      if (tingkatResiko == 'rendah') {
        arr = [
          ...arr,
          [value_e_1, 'Form Penilaian E 1'],
          [value_i52_1, 'Form Penilaian I 5-2-1'],
          [value_i8_1, 'Form Penilaian I 8-1'],
          [value_i9_2, 'Form Penilaian I 9-2'],
        ]
      }

      return this.multiConditions(arr)
    },
    async submitNilai() {
      if (this.checkForm()) {
        await this.$store.commit('kplhStore/SUBMIT_PENILAIAN', {
          final_result: this.countValue(),
          tingkat_resiko: this.$tingkatResikoValue(),
        })
      }
    },
    async getHseUser() {
      const kode = this.$store.state.kplhStore.choosed_company
      console.log('kode: ', kode)
      try {
        const { data } = await axios({
          method: 'GET',
          url: `${api_lp}/api/v1/vendor/user-hse/${kode}`,
        })

        if (data && data.status == 'success') {
          console.log('user hse: ', data.data)
          const hseCompanyUser = await data.data.reduce((res, item) => {
            if (item.company_detail.role_id == 7) res.push(item.company_detail)

            return res
          }, [])

          const kttCompanyUser = await data.data.reduce((res, item) => {
            if (item.company_detail.role_id == 13) res.push(item.company_detail)
            return res
          }, [])

          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            value: [{ id: null, name: 'Pilih Head HSE' }, ...hseCompanyUser],
            name: 'head_hse_options',
          })

          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            value: [{ id: null, name: 'Pilih KTT' }, ...kttCompanyUser],
            name: 'ktt_options',
          })

          console.log('ktt_options: ', kttCompanyUser)
        }
      } catch (error) {
        console.log('error', error)
      }
    },
    openReviewHead() {
      this.$store.commit('kplhStore/SET_KPLH_FORM', {
        name: 'is_catatan_head_open',
        value: true,
      })
    },
    closeReviewHead() {
      this.$store.commit('kplhStore/SET_KPLH_FORM', {
        name: 'is_catatan_head_open',
        value: false,
      })
    },
    async needReviewHead(catatan) {
      const id = this.$route.params.id
      const user_id = this.$route.params.user

      await this.$store.commit('kplhStore/NEED_REVIEW_HEAD', {
        id,
        note: catatan,
      })

      // const url = `${api}/api/v1/request/review-head-hse/${id}`

      // this.$store.commit('kplhStore/SET_KPLH_FORM', {
      //   name: 'globalLoading',
      //   value: true,
      // })
      // try {
      //   const { data: response } = await axios({
      //     method: 'POST',
      //     url,
      //     data: {
      //       user_id,
      //       note: catatan,
      //     },
      //   })

      //   if (response && response.status == 'success') {
      //     this.is_catatan_head_open = false
      //     await this.$store.commit('SET_NOTIF', response.message)
      //     await this.$store.commit('kplhStore/SET_KPLH_FORM', {
      //       name: 'globalLoading',
      //       value: false,
      //     })
      //     await this.$store.commit('kplhStore/SET_KPLH_FORM', {
      //       name: 'is_head_approved',
      //       value: true,
      //     })
      //   }
      // } catch (error) {
      //   console.log(
      //     '🚀 ~ file: selesai-hoc.vue ~ line 107 ~ needReview ~ error',
      //     error
      //   )
      //   this.$store.commit(
      //     'SET_NOTIF',
      //     this.$get(error, 'response.data.message', 'Error')
      //   )
      //   this.$store.commit('kplhStore/SET_KPLH_FORM', {
      //     name: 'globalLoading',
      //     value: false,
      //   })
      // }
    },
    open() {
      this.is_catatan_open = true
    },
    close() {
      this.is_catatan_open = false
    },
    async needReviewHSE(catatan) {
      const id = this.$route.params.id
      const user_id = this.$route.params.user
      const url = `${api}/api/v1/request/review-hse/${id}`

      this.$store.commit('kplhStore/SET_KPLH_FORM', {
        name: 'globalLoading',
        value: true,
      })
      try {
        const { data: response } = await axios({
          method: 'POST',
          url,
          data: {
            user_id,
            note: catatan,
          },
        })

        if (response && response.status == 'success') {
          this.is_catatan_open = false
          await this.$store.commit('SET_NOTIF', response.message)
          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'globalLoading',
            value: false,
          })
          await this.$store.commit('kplhStore/SET_KPLH_FORM', {
            name: 'is_hse_validation',
            value: true,
          })
        }
      } catch (error) {
        console.log(
          '🚀 ~ file: selesai-hoc.vue ~ line 107 ~ needReview ~ error',
          error
        )
        this.$store.commit(
          'SET_NOTIF',
          this.$get(error, 'response.data.message', 'Error')
        )
        this.$store.commit('kplhStore/SET_KPLH_FORM', {
          name: 'globalLoading',
          value: false,
        })
      }
    },
    async approveHead() {
      // console.log(this.countValue(), this.$tingkatResikoValue()``)
      await this.$store.commit('kplhStore/APPROVE_HEAD_HSE', {
        final_result: this.countValue(),
        tingkat_resiko: this.$tingkatResikoValue(),
      })
    },
  },
}
</script>
